import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import pageData from '../../../data/flexibel';
import Content from '../../../components/layout/Content';
import BottomNav from '../../../components/layout/BottomNav';

const Main = ({
  currentPageNum, tutorial, quiz, hasNav,
}) => {
  // Get page data from data/pageData.js
  const currentPageData = pageData.find(page => page.order === currentPageNum);
  return (
    <div className="Shell">
      <Content header>
        <div className="container">
          <Helmet>
            <title>{`Jakten | ${currentPageData.title}`}</title>
          </Helmet>

          <div className="main__content">{tutorial}</div>

          {quiz ? (
            <div className="quiz-section">
              <div className="quiz__content">{quiz}</div>
            </div>
          ) : null}

          {hasNav ? (
            <BottomNav
              navTitle={currentPageData.navTitle}
              currentPageNum={currentPageNum}
              pageData={pageData}
            />
          ) : null}
        </div>
      </Content>
    </div>
  );
};

Main.propTypes = {
  tutorial: PropTypes.node.isRequired,
  quiz: PropTypes.node,
  hasNav: PropTypes.bool,
  currentPageNum: PropTypes.number.isRequired,
};

Main.defaultProps = {
  hasNav: true,
  quiz: '',
};

export default Main;



// WEBPACK FOOTER //
// ./src/pages/flexibel/components/_Main.js